"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var navigationStepperStyles_1 = require("./navigationStepperStyles");
var core_1 = require("@material-ui/core");
var useNavigationSteps_1 = require("../../../hooks/useNavigationSteps");
var Translation_1 = require("../../../../../../common/components/presentation/Translation/Translation");
var react_router_1 = require("react-router");
var MainHeaderWithBackLink_1 = require("../../../../../../common/components/presentation/MainHeader/MainHeaderWithBackLink");
var collectedFilters_1 = require("../../../../../../common/service/collectedFilters");
var queryString = require("query-string");
var NavigationStepLabels_1 = require("../../../enum/NavigationStepLabels");
var useGetDeal_1 = require("../../../../../common/hooks/queries/useGetDeal");
var NameplateOEMCodes_1 = require("../../../../../../common/enum/NameplateOEMCodes");
var usePlatformConfig_1 = require("../../../../../../common/react/usePlatformConfig");
var NavigationStepper = function () {
    var history = react_router_1.useHistory();
    var styles = navigationStepperStyles_1.default();
    var _a = useNavigationSteps_1.default(), steps = _a.steps, activeStep = _a.activeStep;
    var _b = collectedFilters_1.default().filters, token = _b.token, expressionsOfInterest = _b.expressionsOfInterest;
    var searchParams = queryString.stringify({ token: token, expressionsOfInterest: expressionsOfInterest }, { arrayFormat: 'comma' });
    var confirmationStep = react_1.useMemo(function () { return steps.findIndex(function (step) { return step.label === NavigationStepLabels_1.NavigationStepLabels.CONFIRMATION; }); }, [
        steps,
    ]);
    var _c = core_1.useTheme().checkoutLite, showSubtitle = _c.showSubtitle, _d = _c.common, activateHeaderTitlePerPage = _d.activateHeaderTitlePerPage, showCustomHeaderTitlePerOemCode = _d.showCustomHeaderTitlePerOemCode, delayConfirmationPage = _c.confirmation.delayConfirmationPage;
    var fetchBreakdownJsonSchema = usePlatformConfig_1.default().platformConfig.fetchBreakdownJsonSchema;
    var data = useGetDeal_1.default(token, (fetchBreakdownJsonSchema !== null && fetchBreakdownJsonSchema !== void 0 ? fetchBreakdownJsonSchema : true)).data;
    var oemCode = react_1.useMemo(function () { var _a; return (_a = data) === null || _a === void 0 ? void 0 : _a.deal.car.nameplate.attributes.oemcode; }, [data]);
    var _e = react_1.useState(!!delayConfirmationPage), hideNavigation = _e[0], setHideNavigation = _e[1];
    var headerTitle = react_1.useCallback(function () {
        if (!!activateHeaderTitlePerPage) {
            return activeStep.translationKey;
        }
        if (!!showCustomHeaderTitlePerOemCode) {
            return oemCode === NameplateOEMCodes_1.NameplateOEMCodes.PASSENGER
                ? 'trans__checkout__confirmation_page__title_enquiry_journey_vehicleType2'
                : 'trans__checkout__confirmation_page__title_enquiry_journey';
        }
        return 'trans__checkout__general__title_enquiry_journey';
    }, [data, activeStep.translationKey]);
    react_1.useEffect(function () {
        var timeout = null;
        if (activeStep.index !== confirmationStep) {
            setHideNavigation(false);
        }
        else {
            timeout = setTimeout(function () {
                setHideNavigation(false);
            }, 1500);
        }
        return function () {
            if (timeout) {
                clearTimeout(timeout);
            }
        };
    }, []);
    if (hideNavigation) {
        return null;
    }
    return (<>
      <MainHeaderWithBackLink_1.default titleTranslation={headerTitle()} withBackLink={activeStep.index !== confirmationStep} stickyHeader/>
      {showSubtitle && (<core_1.Typography variant="body2" className={styles.subHeaderText}>
          <Translation_1.default id="trans__checkout__general__subtitle_enquiry_journey"/>
        </core_1.Typography>)}
      <core_1.Stepper activeStep={activeStep.index} className={styles.stepper} connector={<core_1.StepConnector classes={{
        line: styles.stepConnector,
        completed: styles.stepConnectorCompleted,
        active: styles.stepConnectorCompleted,
    }}/>} data-test="container:navigation:stepper">
        {steps.map(function (_a, index) {
        var label = _a.label, pathname = _a.pathname;
        var stepProps = {};
        var isLastStep = activeStep.index === steps.length - 1;
        if (isLastStep) {
            stepProps.completed = true;
        }
        var stepLabel = (<core_1.StepLabel classes={{
            label: styles.stepLabel,
            active: styles.active,
            completed: styles.completed,
            iconContainer: styles.iconContainer,
            root: styles.root,
        }} StepIconProps={{ classes: { text: styles.stepIconText } }} data-test={"navigation:step:" + label} data-test-active={index === activeStep.index} data-test-completed={index < activeStep.index || isLastStep}>
              <Translation_1.default id={"trans__checkout__navigation__" + label}/>
            </core_1.StepLabel>);
        return (<core_1.Step key={label} {...stepProps}>
              {index < activeStep.index ? (<core_1.StepButton className={styles.stepButton} onClick={function () { return history.push({ pathname: pathname, search: searchParams }); }}>
                  {stepLabel}
                </core_1.StepButton>) : (stepLabel)}
            </core_1.Step>);
    })}
      </core_1.Stepper>
    </>);
};
exports.default = NavigationStepper;
